export default __webpack_public_path__ + "static/media/iconWhatsapp.d6b0d068.svg";